import { InfoSection } from '../../components/@next/infoSection';

export const AboutPage = () => {
  return (
    <>
      <InfoSection
        title="About us"
        information={
          <div className="pt-5">
            <p>
              Secure Trade Club (STC) is an innovative platform designed with the Serious Collector
              in mind.
            </p>
            <br />
            <p>
              Our Founders are all collectors and have been involved in various Hobbies since they
              were kids and love the hunt!
            </p>
            <br />
            <p>
              From picking at yard sales, to collecting Sports Cards from Baseball Card Shops the
              journey to STC has been an exciting ride.
            </p>
            <br />
            <p>
              However, the purity of the Hobby has been lost in big business and making the
              simplicity of trading collectibles with those who share a similar passion a thing of
              the past.
            </p>
            <br />
            <p>
              We want to bring that back. So on STC you can Trade, Buy and Sell your Collectibles
              with people who share the same interests and passions you do all in a Secure
              environment.
            </p>
          </div>
        }
      />
    </>
  );
};
